import {Izbor} from "../../../komponente/izbor/Izbor";
import podaci from './ravna-gora.json';

export default class extends Izbor {

  constructor() {
    super(podaci);
    this.podaciFajl = 'ravna-gora.json'
  }

}



// WEBPACK FOOTER //
// ./src/hronologija/1941/05-15/RavnaGora.js